import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

interface BackButtonProps {
  /** Where back goes. Defaults to the browser's own history. */
  to?: string;
  /** Layout only — the margin that separates it from the heading below. */
  className?: string;
}

/**
 * The way back out of a step of signing in.
 *
 * At the top of the column rather than under the submit, because it is a way
 * out and not a second choice: somebody on the code screen who mistyped their
 * address is looking upwards for the way back, not down past the button they
 * are trying not to press.
 *
 * It carries the brand ink rather than the muted grey the rest of the screen's
 * secondary text wears — this is the one thing above the heading, and grey
 * there reads as a caption rather than as something to press.
 */
const BackButton: React.FC<BackButtonProps> = ({ to, className = "" }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => (to ? navigate(to, { replace: true }) : navigate(-1))}
      className={`inline-flex items-center gap-1 text-[15px] font-medium text-[#00424B] hover:text-brand-dark transition-colors ${className}`}
    >
      <ChevronLeft aria-hidden="true" className="w-4 h-4" />
      Back
    </button>
  );
};

export default BackButton;
